import logo from './logo.svg';
import './App.css';
import Homepage from './pages';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import SignInPage from './pages/SingIn';
import { AuthContext } from './context/AuthContext';
import { useContext } from 'react';

function App() {
  const { user } = useContext(AuthContext);
  console.log(user);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
         
          <Route
            path="/"
            element={user ? <Homepage /> : <SignInPage />}
          ></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
